<template lang="pug">
  .component-translation-add
    .row(v-if="Object.keys(translations).length > 0")
      .column.large-4
        slot
        ul.accordion(data-accordion='', data-allow-all-closed='true', v-f-accordion="", v-if="translations !== []" )
          li.accordion-item(data-accordion-item='' v-for="(values,group) in translations")
            a.accordion-title(href='#') {{group.toUpperCase()}}
            .accordion-content(data-tab-content='')
              div(v-for="value in values" )
                a.small(@click="openEditor(value.key, group)") {{value.key}}
      .column(v-if="Object.keys(selected).length" )
        .card.p-2
          span.fa.fa-times.text-right(@click="selected = {}")
          TranslationEdit(:item="selected",  :delete-button="selected.id !==undefined")
</template>

<script>
import ActionButton from '../../components/structure/ui/ActionButton'
import LoadingSpinner from "../../components/structure/LoadingSpinner";
import TranslationEdit from "./TranslationEdit.vue";

export default {
  name: 'GroupedTranslation',
  components: {TranslationEdit, LoadingSpinner, ActionButton},
  data() {
    return {
      selected: {}
    }
  },
  created() {

  },
  methods: {
    openEditor(key, group) {
      this.selected = this.translations[group].filter((item) => item.key === key)[0]
    },
  },
  computed: {},
  props: ['translations']
}
</script>

<style>


</style>



// WEBPACK FOOTER //
// GroupedTranslation.vue?03356f86